import React from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { createTheme } from '@material-ui/core/styles'
import { ThemeProvider } from "@material-ui/styles"
import Alert from '@material-ui/lab/Alert';

import AuthenticationUtil from "../utils/AuthenticationUtil"
import { getUserCompanies } from "../utils/common"
import privateRoutes from "../routes/privateRoutes"
import PrivateLayout from "./Private"
import PublicLayout from "./Public"
import NotFound from "./NotFound"
import { APP_NAME, AUTH_URL } from "../../../constants"
import { deepOrange } from '@material-ui/core/colors';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0071e3',
      contrastText: "#fff",
    },
    secondary: {
      main: deepOrange[400],
      contrastText: "#fff",
    }
  },
})

const MasterLayout = () => {
  const { location } = window
  const { isAuthenticated, getUser } = AuthenticationUtil

  const urlParams = new URLSearchParams(location.search)
  const accessTokenFromOmniAuth = urlParams.get("accessToken")
  const refreshTokenFromOmniAuth = urlParams.get("refreshToken")

  if (accessTokenFromOmniAuth && refreshTokenFromOmniAuth) {
    AuthenticationUtil.clearTokens()
    AuthenticationUtil.authenticateUser({
      accessToken: accessTokenFromOmniAuth,
      refreshToken: refreshTokenFromOmniAuth,
    })
  }

  const user = getUser()
  const userCompanies = getUserCompanies(user)

  if (user && userCompanies.length < 1) {
    <Alert severity="error">
      Your account isn't authorized to use {APP_NAME}.
    </Alert>
    return AuthenticationUtil.logout()
  }

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          {privateRoutes.map(
            ({ component, path, parentComponent, isPlain }) => (
              <Route
                exact
                path={path}
                key={path}
                element={
                  <PrivateLayout
                    Component={component}
                    ParentComponent={parentComponent}
                    userCompanies={userCompanies}
                    isPlain={isPlain}
                  />
                }
              />
            ),
          )}

          <Route path="*" element={<PublicLayout Component={NotFound} />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default MasterLayout
